<template>
  <section class="product-description flex flex-col gap-4">
    <!--eslint-disable vue/no-v-html-->
    <ProductDescriptionSection
      v-for="(section, sectionIndex) in productDescription.sections"
      :key="sectionIndex"
      :section="section"
      :section-index="sectionIndex"
    />

    <p
      v-if="productDescription.additional"
      v-html="productDescription.additional"
    />
  </section>
</template>

<script lang="ts">

import type { ProductDescription } from '~~/types/product/ProductDescription';

export default defineComponent({
  name: 'ProductDescription',

  props: {
    productDescription: {
      type: Object as PropType<ProductDescription>,
      default: () => {

        return {};
      
      },
    },
  },
});

</script>
